// File: src/components/UploadPaperJSON.js

import React from "react";
import { db } from "../firebase";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";

const UploadPaperJSON = () => {
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const text = await file.text();
      const papers = JSON.parse(text);

      for (const paper of papers) {
        const title = paper.title?.trim();
        const normalizedTitle = title.toLowerCase();

        const q = query(collection(db, "papers"), where("title_normalized", "==", normalizedTitle));
        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          console.log(`Skipped duplicate: ${title}`);
          continue;
        }

        await addDoc(collection(db, "papers"), {
          ...paper,
          title: title,
          title_normalized: normalizedTitle,
          authors: paper.authors.replace(/,\s+/g, ",").split(",").map((a) => a.trim()),
          keywords: paper.keywords.replace(/,\s+/g, ",").split(",").map((k) => k.trim()),
          votes: 0,
          visibility: "public",
          readers: "Everyone",
          source: "OpenReview",
        });

        console.log(`Added: ${title}`);
      }

      alert("Finished uploading papers!");
    } catch (err) {
      alert("Failed to upload: " + err.message);
    }
  };

  return (
    <div style={{ marginTop: 30 }}>
      <h3>📁 Upload JSON of Papers</h3>
      <input type="file" accept=".json" onChange={handleFileUpload} />
    </div>
  );
};

export default UploadPaperJSON;
